import * as React from 'react';
import styled from 'styled-components';
import {Link} from 'react-router-dom';
import {Logo} from '@components/common/Logo';
import {Section} from '@components/landing/common/Section';
import {areSignupsBlocked} from '@config';

type CTAProps = {
  purple: boolean
}

export function CTA({purple}: CTAProps): JSX.Element {
  return (
    <Section background rounded>
      <LogoContainer>
        <Logo size={100} imageColor="gradient" />
      </LogoContainer>
      <TextContainer>
        <StyledText>
            Download the best daily crypto data in the world, in less than 10
            minutes.
        </StyledText>
        {!areSignupsBlocked() && (
          <StyledLink
            onClick={() => {
              window.scrollTo(0, 0);
            }}
            to="/register"
          >
              Sign Up
          </StyledLink>
        )}
      </TextContainer>
    </Section>
  );
}

const Background = styled.div<{ purple: boolean }>`
  background: ${(props) =>
    props.purple ?
      'linear-gradient(135deg, rgb(125, 87, 244) 50%, rgb(255, 255, 255) 150%);' :
      'linear-gradient(135deg,rgb(31, 135, 229) 50%,rgb(255, 255, 255) 150%);'};
  transform: skewY(-4deg);
  transform-origin: 0;
  height: 100vh;
  width: 100% !important;
  padding-left: 50px;
  padding-right: 50px;
  min-height: 700px;
`;

const Container = styled.div`
  gap: 15px;
  align-items: center;
  width: 100% !important;
  height: 100vh;
  border-radius: 0 !important;
  margin-top: 0;
  transform: skewY(4deg);
  transform-origin: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const LogoContainer = styled.div`
  filter: brightness(130%);
`;

const TextContainer = styled.ul`
  display: flex;
  flex-direction: column;
  padding-left: 0;
  align-items: center;
  max-width: 600px;
`;

const StyledText = styled.h1`
  font-weight: 700;
  color: white;
  font-family: Inter, Raleway, sans-serif !important;
  align-items: center;
  text-align: center;
  justify-content: center;
`;

const StyledLink = styled(Link)`
  text-transform: none !important;
  font-size: 16px;
  border-radius: 30px;
  background: rgba(255, 255, 255, 0.15);
  border: null;
  color: #fff !important;
  font-weight: 500;
  padding: 10px;
  text-align: center;
  line-height: 20px;
  vertical-align: middle;
  margin: 2px;

  &:hover {
    opacity: 0.7;
    cursor: pointer;
  }
`;
